import React, { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AuthLayout from '../components/AuthLayout';
import TextInput from '../components/TextInput';
import Button from '../components/Button';
import ErrorBanner from '../components/ErrorBanner';
import { forgotPassword } from '../api/authApi';
import { ApiError } from '../types/auth.types';
import styles from './ForgotPasswordPage.module.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [fieldError, setFieldError] = useState<string | undefined>();
  const [generalError, setGeneralError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setGeneralError(null);

    if (!email.trim()) {
      setFieldError('Ingresá tu email.');
      return;
    }
    setFieldError(undefined);

    setLoading(true);
    try {
      await forgotPassword({ email });
      setSent(true);
    } catch (error) {
      if (axios.isAxiosError<ApiError>(error)) {
        setGeneralError(error.response?.data?.mensaje ?? 'Ocurrió un error. Intentá nuevamente.');
      } else {
        setGeneralError('Ocurrió un error. Intentá nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout title="Recuperar contraseña" logoSize={150}> <br />
      {sent ? (
        <div className={styles.successState}>
          <svg
            viewBox="0 0 24 24"
            width="40"
            height="40"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className={styles.envelopeIcon}
          >
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="M3 7l9 6 9-6" />
          </svg>
          <p className={styles.successText}>
            Si el correo está registrado, recibirás un enlace en los próximos minutos.
          </p>
          <Link to="/login" className={styles.backLink}>
            Volver al inicio de sesión
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} noValidate>
          <p className={styles.description}>
            Ingresá tu email y te enviaremos un enlace para restablecer tu contraseña.
          </p>
          {generalError && <ErrorBanner message={generalError} onClose={() => setGeneralError(null)} />}
          <TextInput
            id="email"
            label="Email"
            type="email"
            value={email}
            onChange={setEmail}
            autoComplete="email"
            error={fieldError}
          />
          <Button type="submit" loading={loading} loadingText="Enviando...">
            Enviar enlace
          </Button>
          <div className={styles.backLinkWrapper}>
            <Link to="/login" className={styles.backLink}>
              Volver al inicio de sesión
            </Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}
